<template>
  <v-form>
    <div v-if="!document">
      <vue-qr-reader :responsive="true" @code-scanned="codeScanned" />
    </div>
    <div v-if="document">
      <v-btn @click="resetScan"><v-icon>mdi-camera</v-icon></v-btn>
      <div v-if="document.start">
        <div><b>{{document.name}}</b> emprunté par <b>{{document.user}}</b> depuis le <b>{{formatedDate}}</b>.</div>
        <v-btn @click="return_document"><v-icon>mdi-home-import-outline</v-icon></v-btn>
      </div>
      <div v-if="!document.start">
        <span><b>{{document.name}}</b> est disponible.</span>
        <v-text-field v-model="user" label="Username" append-icon="mdi-account" dense @change="onUserChange" />
        <v-checkbox v-model="rememberme" label="Remember me" dense @change="onRemembermeChange" />
        <v-btn v-if="user && user.length>=3" @click="borrow_document"><v-icon>mdi-home-export-outline</v-icon></v-btn>
      </div>
    </div>
  </v-form>
</template>

<script>
import config from '@/config.js'
import axios from 'axios'
import VueQrReader from 'vue-qr-reader/dist/lib/vue-qr-reader.umd.js'

export default {
  name: "Home",
  components: {
    VueQrReader,
  },
  data: () => ({
    document: null,
    user: localStorage.user,
    rememberme: !!localStorage.user
  }),
  computed: {
    formatedDate: function() {
      return new Date(this.document.start).toLocaleDateString(navigator.language)
    },
  },
  methods: {
    resetScan() {
      this.document = null;
    },
    async codeScanned(code) {
      const res = (await axios.get(`${config.apiUrl}/document/${code}`))
      this.document = res.data
    },
    async borrow_document() {
      const res = await axios.post(`${config.apiUrl}/document/${this.document.id}`, { user: this.user})
      this.document = res.data
    },
    async return_document() {
      const res = await axios.post(`${config.apiUrl}/document/${this.document.id}`)
      this.document = res.data
    },
    onUserChange() {
      if(this.rememberme) {
        localStorage.user = this.user
      }
    },
    onRemembermeChange() {
      if(this.rememberme) {
        localStorage.user = this.user ? this.user : ''
      } else {
        localStorage.clear()
      }
    },
  }
}
</script>

<style scoped>
.v-input--checkbox {
  transform-origin: top left;
  transform: scale(0.75);
}
</style>
